import { Box } from 'components/widgets/Box'
import { Icon } from 'components/widgets/Icon'
import { Pressable } from 'components/widgets/Pressable'
import { Text } from 'components/widgets/Text'
import React, { useState } from 'react'

type CollapsibleSectionProps = {
  sectionTitle: string
  bodyContent: JSX.Element
}

export const CollapsibleSection = ({ sectionTitle, bodyContent }: CollapsibleSectionProps) => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(true)

  const toggleSectionViewState = () => {
    setIsCollapsed(!isCollapsed)
  }

  return (
    <>
      <Pressable onPress={toggleSectionViewState}>
        <Box
          testID='SectionHeaderContainer'
          height={44}
          align='center'
          flexDirection='row'
          margin={{ top: 'md' }}
        >
          <Icon rotation={isCollapsed ? 0 : 90} name='triangle-arrow' size={15} color='black' />
          <Box flex={1} margin={{ left: 'md' }}>
            <Text color='black' numberOfLines={1}>
              {sectionTitle}
            </Text>
          </Box>
        </Box>
      </Pressable>

      {!isCollapsed && bodyContent}
    </>
  )
}
